import { Header } from '@/components/Layout/Header/Header';
import { Tabs } from '@/components/Ui';
import React from 'react';
import { useCoupons } from './coupons.hook';
import filterIconActive from '@/assets/icons/filterIconActive.svg';
import filterIcon from '@/assets/icons/filterIcon.svg';
import CouponList from '@/components/Views/CouponList/CouponList';
import { FadeLoader } from 'react-spinners';
import { Button, SearchBar } from '@/components/Common';
import PackageList from '@/components/Views/PackageList/PackageList';
import CouponForm from '@/pages/Coupons/CouponForm';
import PackageForm from './PackageForm';

import ValidationPackageDeletion from './ValidationPackageDeletion';

const Coupons = () => {
  const {
    activeTab,
    setActiveTab,
    loadCoupons,
    filterSelections,
    setIsOpenFilter,
    currentPageTitle,
    setCurrentPageTitle,
    openCreateModal,
    formMode,
    openCreatePackage,
    loadPackages,
  } = useCoupons();

  return (
    <div className="flex flex-col max-h-screen">
      <Header title={currentPageTitle} userName="Mas Aly" role="Admin" />
      <CouponForm mode={formMode} />
      <PackageForm mode={formMode} />
      <ValidationPackageDeletion />
      <div className="flex flex-col items-start justify-start gap-4">
        <div className="my-10">
          <Tabs
            activeIndex={activeTab}
            setActiveIndex={() => {
              setActiveTab((prev) => (activeTab === 0 ? prev + 1 : prev - 1));
              setCurrentPageTitle &&
                setCurrentPageTitle(
                  activeTab === 0 ? 'Les codes promo' : 'Les Offres',
                );
            }}
            tabs={[
              { id: 1, title: 'Offre' },
              { id: 2, title: 'Code promo' },
            ]}
          />
        </div>

        <div className="flex justify-between items-center bg-[#232323] w-full rounded-lg pt-4 pb-2  px-3">
          <div className="flex">
            <SearchBar
              type="text"
              maxLength={9}
              placeholder="Rechercher un code"
              className="!w-[25rem] mb-2"
            />
            <div className="relative">
              {Object.keys(filterSelections).length > 0 && (
                <span className="absolute -top-[7px] -right-[7px] text-black text-[10px] size-[20px] bg-primary rounded-full flex items-center justify-center font-semibold">
                  {Object.keys(filterSelections).length}
                </span>
              )}
              <div className="ml-[11px] size-[45px] bg-[#2D2D2D] rounded-[8px] flex items-center justify-center">
                <img
                  src={
                    Object.keys(filterSelections).length > 0
                      ? filterIconActive
                      : filterIcon
                  }
                  alt="filter"
                  className="cursor-pointer"
                  onClick={() => setIsOpenFilter(true)}
                />
              </div>
            </div>
          </div>

          <div style={{ width: '12.5rem' }}>
            <Button
              title={activeTab === 0 ? 'Nouvelle offre' : 'Ajouter code promo'}
              onClick={() =>
                activeTab === 1 ? openCreateModal() : openCreatePackage()
              }
            />
          </div>
        </div>

        {loadCoupons || loadPackages ? (
          <div className="w-full h-[50vh] flex items-center justify-center">
            <FadeLoader color="#FEC200" />
          </div>
        ) : (
          <div className="w-full">
            {activeTab === 0 && <PackageList />}
            {activeTab === 1 && <CouponList />}
          </div>
        )}
      </div>
    </div>
  );
};

export default Coupons;
